
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([cdv]|xy)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
